'use client';
import React from 'react';
import 'flag-icons/css/flag-icons.min.css';

interface FlagIconProps {
  countryCode: string;
  className?: string;
  size?: number;
}

/**
 * Renders an SVG country flag using the flag-icons library.
 * countryCode should be ISO 3166-1 alpha-2 (e.g. "US", "VN", "JP").
 * Special mapping: "UK" → "GB"
 */
export default function FlagIcon({ countryCode, className = '', size = 16 }: FlagIconProps) {
  // Normalize: flag-icons uses lowercase ISO codes; UK → GB
  const normalized = (countryCode === 'UK' ? 'GB' : countryCode).toLowerCase();

  return (
    <span
      className={`fi fi-${normalized} ${className}`}
      style={{ width: size, height: size, borderRadius: 2, display: 'inline-block', backgroundSize: 'cover', flexShrink: 0 }}
      role="img"
      aria-label={`Flag of ${countryCode}`}
    />
  );
}
